import React from 'react';
import {BrowserRouter, Routes, Route, useLocation} from 'react-router-dom';
import {DatabaseProvider} from './src/context/DatabaseContext';
import {ToastProvider} from './src/context/ToastContext';
import {NotificationProvider} from './src/context/NotificationContext';
import {AuthProvider, useAuth} from './src/providers/AuthProvider';
import ErrorBoundary from './src/components/ErrorBoundary';
import BottomTabs from './src/components/BottomTabs';
import ToastContainer from './src/components/Toast';
import ProtectedRoute from './src/components/ProtectedRoute';
import LoadingScreen from './src/components/LoadingScreen';
import MainMenuScreen from './src/screens/MainMenuScreen';
import HomeScreen from './src/screens/HomeScreen';
import DailyValuesScreen from './src/screens/DailyValuesScreen';
import FoodDiaryScreen from './src/screens/FoodDiaryScreen';
import ProfileScreen from './src/screens/ProfileScreen';
import HistoryScreen from './src/screens/HistoryScreen';
import ScanScreen from './src/screens/ScanScreen';
import ShoppingListScreen from './src/screens/ShoppingListScreen';
import WaterTrackerScreen from './src/screens/WaterTrackerScreen';
import LoginScreen from './src/screens/auth/LoginScreen';
import SignupScreen from './src/screens/auth/SignupScreen';
import {colors} from './src/theme/colors';
import './src/styles/global.css';

// Component to conditionally show bottom tabs
const AppContent = () => {
  const location = useLocation();
  const {loading} = useAuth();
  const isAuthRoute = location.pathname === '/login' || location.pathname === '/signup';

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div style={appStyles.container}>
      <a href="#main-content" className="skip-link">
        דלג לתוכן הראשי
      </a>
      <ToastContainer />
      <main id="main-content" style={appStyles.content} role="main">
        <Routes>
          {/* Auth routes - public */}
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/signup" element={<SignupScreen />} />
          
          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainMenuScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/daily-values"
            element={
              <ProtectedRoute>
                <DailyValuesScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/food-diary"
            element={
              <ProtectedRoute>
                <FoodDiaryScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfileScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-food"
            element={
              <ProtectedRoute>
                <HomeScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/scan"
            element={
              <ProtectedRoute>
                <ScanScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <HistoryScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/today"
            element={
              <ProtectedRoute>
                <DailyValuesScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/shopping-list"
            element={
              <ProtectedRoute>
                <ShoppingListScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/water-tracker"
            element={
              <ProtectedRoute>
                <WaterTrackerScreen />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      {!isAuthRoute && <BottomTabs />}
    </div>
  );
};

const App = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <NotificationProvider>
          <ToastProvider>
            <DatabaseProvider>
              <BrowserRouter>
                <AppContent />
              </BrowserRouter>
            </DatabaseProvider>
          </ToastProvider>
        </NotificationProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
};

const appStyles = {
  container: {
    minHeight: '100vh',
    backgroundColor: colors.bg,
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 60, // Space for bottom tabs
  },
  content: {
    flex: 1,
    overflowY: 'auto',
  },
};

export default App;
